import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { DossierAssignmentType } from "./dossierAssignmentType.model";
import { config } from 'app/_shared/project.config';

@Injectable({
    providedIn: 'root',
})

export class DossierAssignmentTypeService extends GenericService<DossierAssignmentType> {

    constructor(private http: HttpClient) {
        super(http, "/DossierAssignment/");
      }
    
    
}